import {React,useState} from "react";
import { Link, NavLink, Route, Routes } from "react-router-dom";
import "./Filter.css";

const Filter = () => {

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="filter-wrapper d-flex justify-around align-center">
            <NavLink to="/FilterRating4"  className="filter-btn" activeClassName="active-fil" >
              Filters
            </NavLink>
            <NavLink to="/FilterRating4+" className="filter-btn"activeClassName="active-fil">
              Rating 4.5+
            </NavLink>
            <NavLink to='/LowPrice' className="filter-btn"activeClassName="active-fil">
              less than 350
            </NavLink>
            <NavLink to="HighPrice" className="filter-btn"activeClassName="active-fil">
            More than 350
            </NavLink>
          </div>
        </div>
      </div>
    </>
  );
};

export default Filter;
